<template>
  <v-dialog v-model="dialog"
            @click:outside="close"
            @keydown.esc="close"
            width="550px">
    <v-card>
      <v-card-text>
        <v-img :src="imageURL"
               contain
               width="500"
               height="500">
        </v-img>
      </v-card-text>
      <v-card-actions>
        <v-btn @click.prevent="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {Form} from 'vform';
import clipboardService from '../../../../../ml/services/clipboardService';
import toastr from 'toastr';
import DOMPurify from 'dompurify';

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        folder: '',
      }),
    }
  },
  computed: {
    downloadURL() {
      return `${this.imageURL}&download=1`;
    },
    imageURL() {
      return `${this.link.qr_code_url}?format=png&size=500&utm_source=mobile_locker_qr_code`;
    }
  },
  methods: {
    close() {
      this.$emit('closed');
    },
    copyURL() {
      clipboardService.copy(this.link.qr_code_url, false)
        .then(() => {
          if (this.link.past_expiration_date) {
            toastr.warning('URL copied to clipboard, but the link is expired so it will not work.', 'Expired URL');
          } else {
            toastr.success(`${DOMPurify.sanitize(this.link.qr_code_url)} copied to clipboard.`, 'URL Copied');
          }
        });
    },
    download() {
      let link = document.createElement('a');
      link.href = `${this.link.qr_code_url}?download=true`;
      link.dispatchEvent(new MouseEvent(`click`, {bubbles: false, closeable: true, view: window}));
    }
  }
}
</script>
